<template>
  <div>
    <v-dialog v-model="dialog.dialogBrowseOrderItem" max-width="800px" scrollable eager>
      <OrderItemBrowse ref="OrderItemBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </OrderItemBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseTestItem" max-width="800px" scrollable eager>
      <TestItemBrowse ref="TestItemBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </TestItemBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseResultItem" max-width="800px" scrollable eager>
      <ResultItemBrowse ref="ResultItemBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </ResultItemBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseSupplier" max-width="800px" scrollable eager>
      <SupplierBrowse ref="SupplierBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </SupplierBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseMethod" max-width="800px" scrollable eager>
      <MethodBrowse ref="MethodBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </MethodBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseAttribute" max-width="800px" scrollable eager>
      <AttributeBrowse ref="AttributeBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </AttributeBrowse>
    </v-dialog>
    <v-toolbar scrollable color="light-blue darken-4" dark>
      <v-spacer></v-spacer>
      <v-btn ref = "buttonNew" color="primary" style="text-transform: capitalize" @click="newTestItem" :disabled="disabledControl.buttonNew">
        <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('new')}}
      </v-btn>
      <v-btn ref = "buttonDelete" color="primary" style="text-transform: capitalize" @click="deleteTestItem" :disabled="disabledControl.buttonDelete">
        <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>{{$t('delete')}}
      </v-btn>
      <v-btn ref = "buttonSave" color="primary" style="text-transform: capitalize" @click="saveTestItem" :disabled="disabledControl.buttonSave">
        <img src="../assets/SoftwareClinicIcon/Save.png" height="30" weight="30"/>{{$t('save')}}
      </v-btn>
      <v-btn ref = "buttonQuery" color="primary" style="text-transform: capitalize" @click="queryTestItem" :disabled="disabledControl.buttonQuery">
        <img src="../assets/SoftwareClinicIcon/Query.png" height="30" weight="30"/>{{$t('query')}}
      </v-btn>
      <v-btn ref = "buttonFind" color="primary" style="text-transform: capitalize" @click="findTestItem" :disabled="disabledControl.buttonFind">
        <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
      </v-btn>
    </v-toolbar>
    <v-container grid-list-xs text-xs-center fluid>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Test Item ID" v-model="testItemData.test_item_id" ref="textFieldTestItemID" :readonly="readOnlyControl.textFieldTestItemID" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-select :items="dropDownData.lis_category" v-model="testItemData.category_skey" @change="changeCategory($event)" item-text="category_desc" item-value="category_skey" label="Category" persistent-hint outlined dense hide-details>
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-checkbox v-model="testItemData.active" label="Active" hide-details>
              </v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Loinc" v-model="testItemData.loinc" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Test Item Description" v-model="testItemData.test_item_desc" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-select :items="dropDownDataSubCategory" v-model="testItemData.sub_category_skey" item-text="sub_category_desc" item-value="sub_category_skey" label="Sub Category" persistent-hint outlined dense hide-details>
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-checkbox v-model="testItemData.required_all_result_item" label="Required All Result Item" hide-details>
              </v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Loinc Desc" v-model="testItemData.loinc_desc" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Test Item Alias ID" v-model="testItemData.alias_id" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="HIS Code" v-model="testItemData.his_cd" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="1">
              <v-checkbox v-model="testItemData.differential_flag" label="Differential" hide-details>
              </v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-text-field label="Standard Time" v-model="testItemData.standard_time" type="number" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-select :items="dropDownData.lis_analyzer_model" v-model="testItemData.model_skey" item-text="model_desc" item-value="model_skey" label="Analyzer Model" persistent-hint outlined dense hide-details>
              </v-select>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Test Item Alias Descrpition" v-model="testItemData.alias_desc" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-textarea
                v-model="testItemData.his_desc"
                outlined hide-details
                color="black"
                label="HIS Description"
                ></v-textarea>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-select :items="dropDownData.time_unit" v-model="testItemData.standard_time_unit" item-text="unit_desc" item-value="unit_cd" label="Standard Time Unit" persistent-hint outlined dense hide-details>
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-text-field label="Turn Around Time" v-model="testItemData.lead_time" type="number" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="nickname" v-model="testItemData.nickname" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Additional Descrpition" v-model="testItemData.additional_desc" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" sm="12" md="3">
                      <v-text-field label="Method" v-model="testItemData.method_code"
                      outlined dense hide-details readonly
                      @click:clear="clearResultItem"
                      clearable>
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" color="blue" @click="browseMethod">mdi-file-find</v-icon>
                          </template>
                          Search Method
                        </v-tooltip>
                      </template>
                    </v-text-field>
                    </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-select :items="dropDownData.time_unit" v-model="testItemData.lead_time_unit" item-text="unit_desc" item-value="unit_cd" label="Turn Around Time Unit" persistent-hint outlined dense hide-details>
              </v-select>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-select :items="dropDownDataSpecimenSticker" v-model="testItemData.sticker_cd" item-text="sticker_desc" item-value="sticker_cd" label="Specimen Sticker" persistent-hint outlined dense hide-details>
              </v-select>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="6" class="pt-2 pb-1 mb-1">
              <v-textarea
                v-model="testItemData.remark"
                outlined hide-details
                color="black"
                label="Remark"
                ></v-textarea>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-checkbox v-model="testItemData.anonymous" label="Anonymous" hide-details>
              </v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-text-field label="Achievement %" v-model="testItemData.achieve_pct" type="number" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
    </v-container>
    <v-tabs center-active dark>
      <v-tab style="text-transform: capitalize"> Result Item </v-tab>
        <v-tab-item eager>
  <v-container fluid>
    <v-row>
      <v-col cols="6">
    <v-data-table
      v-model="vDataTableResultItem.selected"
      :headers="headersResultItem"
      :items="vDataTableResultItem.data"
      :search="vDataTableResultItem.search"
      show-select
      fixed-header
      :page.sync="vDataTableResultItem.options.page"
      :itemsPerPage.sync="vDataTableResultItem.options.itemsPerPage"
      :options.sync="vDataTableResultItem.options"
      :height="300"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="test_item_skey"
      class="fill-height">
      <template v-slot:header.win_name="{ header }">
          {{ header.text.toUpperCase() }}
      </template>
      <template v-slot:header.data-table-select="{ on, props }">
        <tr>
          <td>
            <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
          </td>
          <td v-if="vDataTableResultItem.selected.length > 0">
            {{vDataTableResultItem.selected.length}}
          </td>
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title></v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog.dialogAddEditResultItem" max-width="1000px" eager>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newResultItem()">
                <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitleResultItem }}</span>
              </v-card-title>
              <v-card-text>
               <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">  
                      <v-text-field label="Seq" v-model="vDataTableResultItem.editedItem.seq" type="number" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field label="Result Item" v-model="vDataTableResultItem.editedItem.result_item_id"
                      outlined dense hide-details readonly
                      @click:clear="clearResultItem"
                      clearable>
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" color="blue" @click="browseResultItem">mdi-file-find</v-icon>
                          </template>
                          Search Result Item
                        </v-tooltip>
                      </template>
                    </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">  
                      <v-text-field label="Result Item Description" v-model="vDataTableResultItem.editedItem.result_item_desc" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">  
                      <v-textarea
                        v-model="vDataTableResultItem.editedItem.remark"
                        outlined hide-details
                        color="black"
                        label="Remark"
                  ></v-textarea>
                  </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="2">
                      <v-checkbox v-model="vDataTableResultItem.editedItem.analyze" label="Analyze" hide-details>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                      <v-checkbox v-model="vDataTableResultItem.editedItem.display_report" label="Display Report" hide-details>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                      <v-checkbox v-model="vDataTableResultItem.editedItem.differential_flag" label="Differential" hide-details>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                      <v-checkbox v-model="vDataTableResultItem.editedItem.display_manual_result" label="Display Manual Result" hide-details>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                      <v-checkbox v-model="vDataTableResultItem.editedItem.require" label="Require" hide-details>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="closeResultItem"">{{$t('cancel')}}</v-btn>
                  <v-btn outlined color="primary" @click="saveResultItem" :disabled="disabledControl.buttonSaveDetail">{{$t('save')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-divider class="mx-1" inset vertical></v-divider>
          <!-- <v-btn outlined color="primary" @click="checkDeleteselected" style="text-transform: capitalize">
            <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>Delete
          </v-btn> -->
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="vDataTableResultItem.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editItemResultItem(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="pink" small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirmResultItem(item)">delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:item.data-table-no="{ item, index }">
        {{((vDataTableResultItem.options.page - 1) * vDataTableResultItem.options.itemsPerPage) + index + 1}}
      </template>
      <template v-slot:no-data>
        <v-alert type="info">
          {{$t('noData')}}
        </v-alert>
      </template>
      <template v-slot:item.analyze="{ item }">
        <v-simple-checkbox v-model="item.analyze" @click.stop="toggleAnalyze(item)" disabled hide-details>
        </v-simple-checkbox>
      </template>
      <template v-slot:item.display_report="{ item }">
        <v-simple-checkbox v-model="item.display_report" @click.stop="toggleDisplayReport(item)" disabled hide-details>
        </v-simple-checkbox>
      </template>
      <template v-slot:item.differential_flag="{ item }">
        <v-simple-checkbox v-model="item.differential_flag" @click.stop="toggleDifferentialFlag(item)" disabled hide-details>
        </v-simple-checkbox>
      </template>
      <template v-slot:item.display_manual_result="{ item }">
        <v-simple-checkbox v-model="item.display_manual_result" @click.stop="toggleDisplayManualResult(item)" disabled hide-details>
        </v-simple-checkbox>
      </template>
      <template v-slot:item.require="{ item }">
        <v-simple-checkbox v-model="item.require" @click.stop="toggleRequire(item)" disabled hide-details>
        </v-simple-checkbox>
      </template>
      <template v-slot:no-results>
        <v-alert type="warning">
          {{stringFormat($t('searchNotFound'),vDataTableResultItem.search)}}
        </v-alert>
      </template>
      <template v-slot:footer>
        <tr class="sticky-table-footer" style="position: absolute">
          <td>Selected({{vDataTableResultItem.selected.length}})s</td> 
        </tr>
      </template>
    </v-data-table>
      </v-col>
      <v-col cols="6">
        <v-data-table
      v-model="vDataTableOutlab.selected"
      :headers="headersOutLab"
      :items="vDataTableOutlab.data"
      :search="vDataTableOutlab.search"
      show-select
      fixed-header
      :page.sync="vDataTableOutlab.options.page"
      :itemsPerPage.sync="vDataTableOutlab.options.itemsPerPage"
      :options.sync="vDataTableOutlab.options"
      :height="300"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="vendor_skey"
      class="fill-height">
      <template v-slot:header.win_name="{ header }">
          {{ header.text.toUpperCase() }}
      </template>
      <template v-slot:header.data-table-select="{ on, props }">
        <tr>
          <td>
            <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
          </td>
          <td v-if="vDataTableOutlab.selected.length > 0">
            {{vDataTableOutlab.selected.length}}
          </td>
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title></v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog.dialogAddEditOutLab" max-width="1000px" eager>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newResultItem()">
                <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitleOutLab }}</span>
              </v-card-title>
              <v-card-text>
               <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">  
                      <v-text-field label="rank" v-model="vDataTableOutlab.editedItem.rank" type="number" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field label="Out Lab No." v-model="vDataTableOutlab.editedItem.vendor"
                      outlined dense hide-details readonly
                      @click:clear="clearOutLab"
                      clearable>
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" color="blue" @click="browseOutLab">mdi-file-find</v-icon>
                          </template>
                          Search Out Lab
                        </v-tooltip>
                      </template>
                    </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">  
                      <v-text-field label="Out Lab Name" v-model="vDataTableOutlab.editedItem.vendor_name" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">  
                      <v-text-field label="Lead Time (Days)" v-model="vDataTableOutlab.editedItem.lead_time" type="number" outlined dense hide-details></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="closeOutLab">{{$t('cancel')}}</v-btn>
                  <v-btn outlined color="primary" @click="saveOutLab" :disabled="disabledControl.buttonSaveDetail">{{$t('save')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-divider class="mx-1" inset vertical></v-divider>
          <!-- <v-btn outlined color="primary" @click="checkDeleteselected" style="text-transform: capitalize">
            <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>Delete
          </v-btn> -->
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="vDataTableOutlab.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editItemOutLab(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="pink" small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirmOutLab(item)">delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:item.data-table-no="{ item, index }">
        {{((vDataTableOutlab.options.page - 1) * vDataTableOutlab.options.itemsPerPage) + index + 1}}
      </template>
      <template v-slot:no-data>
        <v-alert type="info">
          {{$t('noData')}}
        </v-alert>
      </template>
      <template v-slot:no-results>
        <v-alert type="warning">
          {{stringFormat($t('searchNotFound'),vDataTableOutlab.search)}}
        </v-alert>
      </template>
      <template v-slot:footer>
        <tr class="sticky-table-footer" style="position: absolute">
          <td>Selected({{vDataTableOutlab.selected.length}})s</td> 
        </tr>
      </template>
    </v-data-table>
      </v-col>
    </v-row>
  </v-container>
    </v-tab-item>
      <v-tab style="text-transform: capitalize"> Attribute </v-tab>
      <v-tab-item eager>
<v-data-table
      v-model="vDataTableAttribute.selected"
      :headers="headersAttribute"
      :items="vDataTableAttribute.data"
      :search="vDataTableAttribute.search"
      show-select
      fixed-header
      :page.sync="vDataTableAttribute.options.page"
      :itemsPerPage.sync="vDataTableAttribute.options.itemsPerPage"
      :options.sync="vDataTableAttribute.options"
      :height="300"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="attr_hdr_skey"
      class="fill-height">
      <template v-slot:header.win_name="{ header }">
          {{ header.text.toUpperCase() }}
      </template>
      <template v-slot:header.data-table-select="{ on, props }">
        <tr>
          <td>
            <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
          </td>
          <td v-if="vDataTableAttribute.selected.length > 0">
            {{vDataTableAttribute.selected.length}}
          </td>
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title></v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog.dialogAddEditAttribute" max-width="1000px" eager>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newResultItem()">
                <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitleAttribute }}</span>
              </v-card-title>
              <v-card-text>
               <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">  
                      <v-text-field label="Seq" v-model="vDataTableAttribute.editedItem.seq" type="number" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field label="Attribute Name" v-model="vDataTableAttribute.editedItem.attr_name"
                      outlined dense hide-details readonly
                      @click:clear="clearAttribute"
                      clearable>
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" color="blue" @click="browseAttribute">mdi-file-find</v-icon>
                          </template>
                          Search Attribute
                        </v-tooltip>
                      </template>
                    </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">  
                      <v-text-field label="Attribute Desc" v-model="vDataTableAttribute.editedItem.attr_desc" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">  
                      <v-checkbox v-model="vDataTableAttribute.editedItem.require" label="Require" hide-details>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">  
                      <v-textarea
                        v-model="vDataTableAttribute.editedItem.remark"
                        outlined hide-details
                        color="black"
                        label="Remark">
                      </v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="closeAttribute">{{$t('cancel')}}</v-btn>
                  <v-btn outlined color="primary" @click="saveAttribute" :disabled="disabledControl.buttonSaveDetail">{{$t('save')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-divider class="mx-1" inset vertical></v-divider>
          <!-- <v-btn outlined color="primary" @click="checkDeleteselected" style="text-transform: capitalize">
            <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>Delete
          </v-btn> -->
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="vDataTableAttribute.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editItemAttribute(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="pink" small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirmAttribute(item)">delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:item.data-table-no="{ item, index }">
        {{((vDataTableAttribute.options.page - 1) * vDataTableAttribute.options.itemsPerPage) + index + 1}}
      </template>
      <template v-slot:item.require="{ item }">
        <v-simple-checkbox v-model="item.require" disabled hide-details>
        </v-simple-checkbox>
      </template>
      <template v-slot:no-data>
        <v-alert type="info">
          {{$t('noData')}}
        </v-alert>
      </template>
      <template v-slot:no-results>
        <v-alert type="warning">
          {{stringFormat($t('searchNotFound'),vDataTableAttribute.search)}}
        </v-alert>
      </template>
      <template v-slot:footer>
        <tr class="sticky-table-footer" style="position: absolute">
          <td>Selected({{vDataTableAttribute.selected.length}})s</td> 
        </tr>
      </template>
    </v-data-table>
      </v-tab-item>
    </v-tabs> 
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import OrderItemBrowse from '@/components/common/OrderItemBrowse'
import TestItemBrowse from '@/components/common/TestItemBrowse'
import ResultItemBrowse from '@/components/common/ResultItemBrowse'
import SupplierBrowse from '@/components/common/SupplierBrowse'
import MethodBrowse from '@/components/common/MethodBrowse'
import AttributeBrowse from '@/components/common/AttributeBrowse'

export default {
  components: {
    OrderItemBrowse,
    TestItemBrowse,
    ResultItemBrowse,
    SupplierBrowse,
    MethodBrowse,
    AttributeBrowse,
  },

  props: ['parentComponent'],

  data () {
    return {
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      dialog: {
        dialogProgress: false,
        dialogAddEditResultItem: false,
        dialogAddEditOutLab: false,
        dialogAddEditAttribute: false,
        dialogBrowseOrderItem: false,
        dialogBrowseTestItem: false,
        dialogBrowseResultItem: false,
        dialogBrowseSupplier: false,
        dialogBrowseMethod: false,
        dialogBrowseAttribute: false,
      },
      stateWindow: '',
      readOnlyControl: {
        textFieldTestItemID: false,
      },
      disabledControl: {
        buttonNew: false,
        buttonDelete: false,
        buttonSave: false,
        buttonQuery: false,
        buttonFind: false,
        buttonSaveDetail: false,
      },
      menu: {
        menuStartDate: false,
        menuDueDate: false,
        menuCompleteDate: false,
        menuEffectiveStartDate: false,
        menuEffectiveStopDate: false,
      },
      testItemData: [],
      vDataTableResultItem: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
      },
      vDataTableOutlab: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
      },
      vDataTableAttribute: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
      },
      sendVar: [],
      dropDownData: [],
      dropDownDataSubCategory: [],
      dropDownDataSpecimenSticker: [],
      progressMessage: '',
    }
  },

  computed: {
    ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
    ...mapState({
      userID: state => `${state.user.profile.user_id}`,
      userFullName: state => `${state.user.profile.user_fullname}`,
    }),
    dateRangeTextRequestDateFromTo () {
      return this.criteria.requestDateFromTo.join(' ~ ')
    },
    dateRangeTextCreatedDateFromTo () {
      return this.criteria.createdDateFromTo.join(' ~ ')
    },
    formTitleResultItem () {
      return this.vDataTableResultItem.editedIndex === -1 ? 'New Result Item' : 'Edit Result Item'
    },
    formTitleOutLab () {
      return this.vDataTableOutlab.editedIndex === -1 ? 'New Out lab' : 'Edit Out lab'
    },
    formTitleAttribute () {
      return this.vDataTableAttribute.editedIndex === -1 ? 'New Attribute' : 'Edit Attribute'
    },
    headersResultItem () {
      return [
        { text: '#', align: 'center', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
        { text: '', align: 'center', value: 'data-table-select', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: 'Seq', align: 'left', value: 'seq', class: 'text-xl-left body-1 black--text' },
        { text: 'Result Item_ID', align: 'left', value: 'result_item_id', class: 'text-xl-left body-1 black--text' },
        { text: 'Result Item Desc', width: '200', align: 'left', value: 'result_item_desc', class: 'text-xl-left body-1 black--text' },
        { text: 'remark', align: 'left', value: 'remark', class: 'text-xl-left body-1 black--text' },
        { text: 'Analyze', align: 'left', value: 'analyze', class: 'text-xl-left body-1 black--text' },
        { text: 'Display Report', align: 'left', value: 'display_report', class: 'text-xl-left body-1 black--text' },
        { text: 'Differential Flag', align: 'left', value: 'differential_flag', class: 'text-xl-left body-1 black--text' },
        { text: 'Display Manual Result', align: 'left', value: 'display_manual_result', class: 'text-xl-left body-1 black--text' },
        { text: 'Require', align: 'left', value: 'require', class: 'text-xl-left body-1 black--text' },
      ]
    },
    headersOutLab () {
      return [
        { text: '#', align: 'center', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
        { text: '', align: 'center', value: 'data-table-select', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: 'Rank', align: 'left', value: 'rank', class: 'text-xl-left body-1 black--text' },
        { text: 'Out Lab No.', align: 'left', value: 'vendor', class: 'text-xl-left body-1 black--text' },
        { text: 'Out Lab Name', width: '200', align: 'left', value: 'vendor_name', class: 'text-xl-left body-1 black--text' },
        { text: 'Lead Time (Days)', align: 'left', value: 'lead_time', class: 'text-xl-left body-1 black--text' },
      ]
    },
    headersAttribute () {
      return [
        { text: '#', align: 'center', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
        { text: '', align: 'center', value: 'data-table-select', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: 'Seq', align: 'left', value: 'seq', class: 'text-xl-left body-1 black--text' },
        { text: 'Attribute Name', align: 'left', value: 'attr_name', class: 'text-xl-left body-1 black--text' },
        { text: 'Attribute Desc', align: 'left', value: 'attr_desc', class: 'text-xl-left body-1 black--text' },
        { text: 'require', align: 'left', value: 'require', class: 'text-xl-left body-1 black--text' },
        { text: 'remark', align: 'left', value: 'remark', class: 'text-xl-left body-1 black--text' },
      ]
    },
    offsetAppBar () {
      return this.getShowAppBar ? this.getAppBarHeight : 0
    }
  },

  watch: {
    'dialog.dialogAddEditResultItem' (val) {
      val || this.closeResultItem()
    },
    'dialog.dialogAddEditOutLab' (val) {
      val || this.closeOutLab()
    },
    'dialog.dialogAddEditAttribute' (val) {
      val || this.closeAttribute()
    },
    stateWindow: function (after, before) {
      try {
        switch (after) {
          case 'NewState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = true
            this.readOnlyControl.textFieldTestItemID = false
            this.$refs.textFieldTestItemID.focus()
            break
          case 'DeleteState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = true
            break
          case 'SaveState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = false
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = false
            break
          case 'QueryState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = true
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = false
            this.readOnlyControl.textFieldTestItemID = false
            this.$refs.textFieldTestItemID.focus()
            break
          case 'FindState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = false
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = false
            this.readOnlyControl.textFieldTestItemID = true
            break
        }
      } catch (e) {
        this.$swal({type: 'error', title: e.message})
      }
    },
  },

  async created () {
    this.retrieveDropDown()
    this.stateWindow = 'QueryState'
    await this.retrieveWpTestItem('')
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    selectLanguage (language) {
    },
    getVarReturn (value) {
      switch (value.childSend) {
        case 'TestItemBrowse':
          this.dialog.dialogBrowseTestItem = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseTestItem':
                  this.retrieveWpTestItem(value.dataSelected[0]['test_item_id'])
                  this.stateWindow = 'FindState'
                  break
              }
          }
          break
        case 'MethodBrowse':
          this.dialog.dialogBrowseMethod = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseMethod':
                  this.testItemData.method_code = value.dataSelected[0]['code']
                  break
              }
          }
          break
        case 'ResultItemBrowse':
          this.dialog.dialogBrowseResultItem = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseResultItem':
                  this.vDataTableResultItem.editedItem.test_item_skey = this.testItemData.test_item_skey
                  this.vDataTableResultItem.editedItem.result_item_skey = value.dataSelected[0]['result_item_skey']
                  this.vDataTableResultItem.editedItem.result_item_id = value.dataSelected[0]['result_item_id']
                  this.vDataTableResultItem.editedItem.result_item_desc = value.dataSelected[0]['result_item_desc']
                  break
              }
          }
          break
        case 'SupplierBrowse':
          this.dialog.dialogBrowseSupplier = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseSupplier':
                  this.vDataTableOutlab.editedItem.test_item_skey = this.testItemData.test_item_skey
                  this.vDataTableOutlab.editedItem.vendor_skey = value.dataSelected[0]['vendor_skey']
                  this.vDataTableOutlab.editedItem.vendor = value.dataSelected[0]['vendor']
                  this.vDataTableOutlab.editedItem.vendor_name = value.dataSelected[0]['vendor_name']
                  break
              }
          }
          break
        case 'AttributeBrowse':
          this.dialog.dialogBrowseAttribute = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseAttribute':
                  this.vDataTableAttribute.editedItem.test_item_skey = this.testItemData.test_item_skey
                  this.vDataTableAttribute.editedItem.attr_hdr_skey = value.dataSelected[0]['attr_hdr_skey']
                  this.vDataTableAttribute.editedItem.attr_name = value.dataSelected[0]['attr_name']
                  this.vDataTableAttribute.editedItem.attr_desc = value.dataSelected[0]['attr_desc']
                  break
              }
          }
          break
      }
    },
    initialize () {
      this.vDataTableResultItem.selected = []
      this.vDataTableResultItem.editedIndex = -1
      this.vDataTableResultItem.editedItem = {
        win_name: '',
        window_comment: ''
      }
      this.vDataTableResultItem.defaultItem = {
        win_name: '',
        window_comment: ''
      }
    },
    browseResultItem () {
      if (this.vDataTableResultItem.editedIndex === -1) {
        this.dialog.dialogBrowseResultItem = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseResultItem'
        this.$refs.ResultItemBrowse.retrieveResultItem()
      }
    },
    browseOutLab () {
      if (this.vDataTableOutlab.editedIndex === -1) {
        this.dialog.dialogBrowseSupplier = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseSupplier'
        this.$refs.SupplierBrowse.retrieveSupplier()
      }
    },
    browseMethod () {
      this.dialog.dialogBrowseMethod = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browseMethod'
      this.$refs.MethodBrowse.retrieveMethod()
    },
    browseAttribute () {
      if (this.vDataTableAttribute.editedIndex === -1) {
        this.dialog.dialogBrowseAttribute = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseAttribute'
        this.$refs.AttributeBrowse.retrieveAttribute()
      }
    },
    clearResultItem () {
      this.dialog.dialogAddEditResultItem = false
      this.vDataTableResultItem.editedItem.result_item_skey = undefined
      this.vDataTableResultItem.editedItem.result_item_id = undefined
      this.vDataTableResultItem.editedItem.result_item_desc = undefined
      this.dialog.dialogAddEditResultItem = true
    },
    clearOutLab () {
      this.dialog.dialogAddEditOutLab = false
      this.vDataTableOutlab.editedItem.vendor_skey = undefined
      this.vDataTableOutlab.editedItem.vendor = undefined
      this.vDataTableOutlab.editedItem.vendor_name = undefined
      this.dialog.dialogAddEditOutLab = true
    },
    clearAttribute () {
      this.dialog.dialogAddEditAttribute = false
      this.vDataTableAttribute.editedItem.attr_hdr_skey = undefined
      this.vDataTableAttribute.editedItem.attr_name = undefined
      this.vDataTableAttribute.editedItem.attr_desc = undefined
      this.dialog.dialogAddEditAttribute = true
    },
    toggleAnalyze (item) {
      // item.analyze = !item.analyze
    },
    toggleDisplayReport (item) {
      // item.display_report = !item.display_report
    },
    toggleDifferentialFlag (item) {
      // item.differential_flag = !item.differential_flag
    },
    toggleDisplayManualResult (item) {
      // item.display_manual_result = !item.display_manual_result
    },
    toggleRequire (item) {
      // item.require = !item.require
    },
    changeCategory (e) {
      this.retrieveDropDownSubCategory(e)
      this.retrieveDropDownSpecimenSticker(e)
    },
    async retrieveDropDownSubCategory (categorySkey) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/testItem/retrieveDropDownSubCategory' + process.env.VUE_APP_DATABASE_TYPE, {
        'category_skey': categorySkey,
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.dropDownDataSubCategory = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async retrieveDropDownSpecimenSticker (categorySkey) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/testItem/retrieveDropDownSpecimenSticker' + process.env.VUE_APP_DATABASE_TYPE, {
        'category_skey': categorySkey,
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.dropDownDataSpecimenSticker = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async newTestItem () {
      await this.retrieveWpTestItem('')
      this.stateWindow = 'NewState'
    },
    async deleteTestItem () {
      this.$swal({
        text: this.stringFormat('Are you sure want to delete Test Item?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          await this.axios.post(process.env.VUE_APP_API + '/testItem/deleteTestItem' + process.env.VUE_APP_DATABASE_TYPE, {
            test_item_skey: this.testItemData.test_item_skey,
          })
            .then(async response => {
              if (response.data.isSuccess) {
                this.$swal({type: 'success', title: response.data.reasonText})
                await this.retrieveWpTestItem('')
                this.stateWindow = 'QueryState'
              } else {
                await this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(async e => {
              await this.$swal({type: 'error', title: e.message})
            })
        }
      })
    },
    async saveTestItem () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/testItem/saveTestItem' + process.env.VUE_APP_DATABASE_TYPE, {
        test_item: this.testItemData,
      })
        .then(async response => {
          if (response.data.isSuccess) {
            await this.retrieveWpTestItem(response.data.data.test_item_id)
            this.stateWindow = 'SaveState'
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            await this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(async e => {
          await this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async queryTestItem () {
      await this.retrieveWpTestItem('')
      this.stateWindow = 'QueryState'
    },
    async findTestItem () {
      var testItemID = this.$refs.textFieldTestItemID.value
      if (testItemID === undefined || testItemID.length === 0) {
        this.dialog.dialogBrowseTestItem = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseTestItem'
        this.$refs.TestItemBrowse.retrieveWpTestItem()
      } else {
        await this.retrieveWpTestItem(testItemID)
        if (this.$refs.textFieldTestItemID.value === undefined || this.$refs.textFieldTestItemID.value.length === 0) {
          var format = require('string-format')
          await this.$swal({type: 'error', title: format('Not Found Test Item ID ({})', testItemID)})
        } else {
          this.stateWindow = 'FindState'
        }
      }
    },
    newResultItem () {
      if (this.testItemData.test_item_skey.length === 0) {
        this.$swal({type: 'error', title: 'กรุณาเลือก Test Item ก่อนจะเพิ่มข้อมูล'})
        this.disabledControl.buttonSaveDetail = true
      } else {
        this.disabledControl.buttonSaveDetail = false
      }
    },
    async retrieveWpTestItem (testItemID) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/testItem/retrieveWpTestItem' + process.env.VUE_APP_DATABASE_TYPE, {
        'test_item_id': testItemID,
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.testItemData = response.data.data[0]
            this.vDataTableResultItem.data = this.testItemData.lis_test_item_result
            this.vDataTableOutlab.data = this.testItemData.lis_test_item_outlab
            this.vDataTableAttribute.data = this.testItemData.lis_test_item_attr
            console.log(this.testItemData)
            this.retrieveDropDownSubCategory(this.testItemData.category_skey)
            this.retrieveDropDownSpecimenSticker(this.testItemData.category_skey)
            this.initialize()
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    retrieveDropDown () {
      this.axios.post(process.env.VUE_APP_API + '/testItem/retrieveDropDown' + process.env.VUE_APP_DATABASE_TYPE, {
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.dropDownData = response.data.data[0]
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    checkDeleteselected () {
      if (this.vDataTableResultItem.selected.length > 0) {
        this.$swal({
          text: 'Are you sure you want to delete selected Order Test Item?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: 'Please select Order Test Item to delete'})
      }
    },
    async deleteSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []

      await this.utils.asyncForEach(this.vDataTableResultItem.selected, async function (x) {
        var val = await this.deleteOrderTestItem(x)

        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))

      // del.forEach(x => {
      //   this.vDataTableResultItem.selected.splice(this.vDataTableResultItem.selected.indexOf(x), 1)
      // })

      for (const x in del) {
        this.vDataTableResultItem.selected.splice(this.vDataTableResultItem.selected.indexOf(x), 1)
      }

      this.dialog.dialogProgress = false
      // this.retrieveWindow(this.appName)
    },
    async deleteTestItemResult (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var testItemSkey = item.test_item_skey
        var resultItemSkey = item.result_item_skey
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/testItem/deleteTestItemResult' + process.env.VUE_APP_DATABASE_TYPE, {
          test_item_skey: testItemSkey,
          result_item_skey: resultItemSkey,
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.vDataTableResultItem.data.indexOf(item) >= 0) {
                this.vDataTableResultItem.data.splice(this.vDataTableResultItem.data.indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    async deleteTestItemOutLab (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var testItemSkey = item.test_item_skey
        var vendorSkey = item.vendor_skey
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/testItem/deleteTestItemOutLab' + process.env.VUE_APP_DATABASE_TYPE, {
          test_item_skey: testItemSkey,
          vendor_skey: vendorSkey,
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.vDataTableOutlab.data.indexOf(item) >= 0) {
                this.vDataTableOutlab.data.splice(this.vDataTableOutlab.data.indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    async deleteTestItemAttr (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var testItemSkey = item.test_item_skey
        var attrHdrSkey = item.attr_hdr_skey
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/testItem/deleteTestItemAttr' + process.env.VUE_APP_DATABASE_TYPE, {
          test_item_skey: testItemSkey,
          attr_hdr_skey: attrHdrSkey,
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.vDataTableAttribute.data.indexOf(item) >= 0) {
                this.vDataTableAttribute.data.splice(this.vDataTableAttribute.data.indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    editItemResultItem (item) {
      this.vDataTableResultItem.editedIndex = this.vDataTableResultItem.data.indexOf(item)
      this.vDataTableResultItem.editedItem = Object.assign({}, item)
      this.dialog.dialogAddEditResultItem = true
    },
    editItemOutLab (item) {
      this.vDataTableOutlab.editedIndex = this.vDataTableOutlab.data.indexOf(item)
      this.vDataTableOutlab.editedItem = Object.assign({}, item)
      this.dialog.dialogAddEditOutLab = true
    },
    editItemAttribute (item) {
      this.vDataTableAttribute.editedIndex = this.vDataTableAttribute.data.indexOf(item)
      this.vDataTableAttribute.editedItem = Object.assign({}, item)
      this.dialog.dialogAddEditAttribute = true
    },
    async deleteItemConfirmResultItem (item) {
      // this.vDataTableResultItem.editedIndex = this.vDataTableResultItem.data.indexOf(item)
      // this.vDataTableResultItem.editedItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat('Are you sure want to delete Result Item?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteTestItemResult(item)
          if (val !== undefined) {
            if (this.vDataTableResultItem.selected.indexOf(item) >= 0) {
              this.vDataTableResultItem.selected.splice(this.vDataTableResultItem.selected.indexOf(item), 1)
            }
          }
        }
      })
    },
    async deleteItemConfirmOutLab (item) {
      // this.vDataTableResultItem.editedIndex = this.vDataTableResultItem.data.indexOf(item)
      // this.vDataTableResultItem.editedItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat('Are you sure want to delete Out Lab?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteTestItemOutLab(item)
          if (val !== undefined) {
            if (this.vDataTableOutlab.selected.indexOf(item) >= 0) {
              this.vDataTableOutlab.selected.splice(this.vDataTableOutlab.selected.indexOf(item), 1)
            }
          }
        }
      })
    },
    async deleteItemConfirmAttribute (item) {
      // this.vDataTableResultItem.editedIndex = this.vDataTableResultItem.data.indexOf(item)
      // this.vDataTableResultItem.editedItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat('Are you sure want to delete Attribute?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteTestItemAttr(item)
          if (val !== undefined) {
            if (this.vDataTableAttribute.selected.indexOf(item) >= 0) {
              this.vDataTableAttribute.selected.splice(this.vDataTableAttribute.selected.indexOf(item), 1)
            }
          }
        }
      })
    },
    closeResultItem () {
      this.dialog.dialogAddEditResultItem = false
      this.$nextTick(() => {
        this.vDataTableResultItem.editedItem = Object.assign({}, this.vDataTableResultItem.defaultItem)
        this.vDataTableResultItem.editedIndex = -1
      })
    },
    closeOutLab () {
      this.dialog.dialogAddEditOutLab = false
      this.$nextTick(() => {
        this.vDataTableOutlab.editedItem = Object.assign({}, this.vDataTableOutlab.defaultItem)
        this.vDataTableOutlab.editedIndex = -1
      })
    },
    closeAttribute () {
      this.dialog.dialogAddEditAttribute = false
      this.$nextTick(() => {
        this.vDataTableAttribute.editedItem = Object.assign({}, this.vDataTableAttribute.defaultItem)
        this.vDataTableAttribute.editedIndex = -1
      })
    },
    async saveResultItem () {
      if (this.vDataTableResultItem.editedItem.seq === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Seq'})
        return
      }
      if (this.vDataTableResultItem.editedItem.result_item_skey === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Result Item'})
        return
      }
      if (this.vDataTableResultItem.editedIndex > -1) {
        if (this.vDataTableResultItem.editedItem.state_row === 'New') {
        } else {
          this.vDataTableResultItem.editedItem.state_row = 'Edit'
        }
        Object.assign(this.vDataTableResultItem.data[this.vDataTableResultItem.editedIndex], this.vDataTableResultItem.editedItem)
        this.closeResultItem()
      } else {
        this.vDataTableResultItem.editedItem.state_row = 'New'
        this.vDataTableResultItem.data.push(this.vDataTableResultItem.editedItem)
        this.closeResultItem()
      }
    },
    async saveOutLab () {
      if (this.vDataTableOutlab.editedItem.rank === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ rank'})
        return
      }
      if (this.vDataTableOutlab.editedItem.vendor_skey === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Out Lab'})
        return
      }
      if (this.vDataTableOutlab.editedItem.lead_time === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Lead Time'})
        return
      }
      if (this.vDataTableOutlab.editedIndex > -1) {
        if (this.vDataTableOutlab.editedItem.state_row === 'New') {
        } else {
          this.vDataTableOutlab.editedItem.state_row = 'Edit'
        }
        Object.assign(this.vDataTableOutlab.data[this.vDataTableOutlab.editedIndex], this.vDataTableOutlab.editedItem)
        this.closeOutLab()
      } else {
        this.vDataTableOutlab.editedItem.state_row = 'New'
        this.vDataTableOutlab.data.push(this.vDataTableOutlab.editedItem)
        this.closeOutLab()
      }
    },
    async saveAttribute () {
      if (this.vDataTableAttribute.editedItem.seq === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Seq'})
        return
      }
      if (this.vDataTableAttribute.editedItem.attr_hdr_skey === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Attribute'})
        return
      }
      if (this.vDataTableAttribute.editedIndex > -1) {
        if (this.vDataTableAttribute.editedItem.state_row === 'New') {
        } else {
          this.vDataTableAttribute.editedItem.state_row = 'Edit'
        }
        Object.assign(this.vDataTableAttribute.data[this.vDataTableAttribute.editedIndex], this.vDataTableAttribute.editedItem)
        this.closeAttribute()
      } else {
        this.vDataTableAttribute.editedItem.state_row = 'New'
        this.vDataTableAttribute.data.push(this.vDataTableAttribute.editedItem)
        this.closeAttribute()
      }
    }
  },
}
</script>
<style scoped>
.sticky-table-footer td {
  font-weight: bold;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  border-top: thin solid rgba(0,0,0,.12);
}
</style>